// extracted by mini-css-extract-plugin
module.exports = {"buttonWhenOpen":"ShowMore_buttonWhenOpen__EgVp0"};